import { render, staticRenderFns } from "./ReplyIcon.vue?vue&type=template&id=b6c10986&"
import script from "./ReplyIcon.vue?vue&type=script&lang=js&"
export * from "./ReplyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports